// extracted by mini-css-extract-plugin
export default {"logo":"CertifiedLogo_logo__VLPbO"};